import * as z from "zod/v4";

export const moveFulfillmentGroups = {
  name: "moveFulfillmentGroups" as const,
  input: z.object({
    fulfillmentGroupIds: z.array(z.string()),
    externalLocationId: z.string(),
  }),
  output: z.object({ success: z.boolean() }),
};
